import { GLOBALS } from './global.environment';

export const ENVIRONMENT = GLOBALS;

// Overwrite general settings.
ENVIRONMENT.name = 'DEV';
ENVIRONMENT.production = false;
ENVIRONMENT.apiConfiguration.baseUrl = 'https://api.test.band-manager.app';
